if (!customElements.get('product-floating-buy')) {
  customElements.define(
    'product-floating-buy',
    class ProductFloatingBuy extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.button = this.querySelector('button');
        if (!target || !this.button) return;

        this.syncDisabled(target);
        this.mutations = new MutationObserver(() => this.syncDisabled(target));
        this.mutations.observe(target, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

        this.note = this.querySelector('.pdp-floating-buy__note');
        if (this.note) {
          this.updateNote();
          this.noteTimer = setInterval(() => this.updateNote(), 60000);
        }
      }

      disconnectedCallback() {
        if (this.mutations) this.mutations.disconnect();
        if (this.noteTimer) clearInterval(this.noteTimer);
      }

      updateNote() {
        const now = new Date();
        const day = now.getDay();
        const show = day >= 1 && day <= 4 && now.getHours() * 60 + now.getMinutes() < 705;
        this.note.hidden = !show;
        if (!show && this.noteTimer) clearInterval(this.noteTimer);
      }

      syncDisabled(target) {
        const disabled = target.hasAttribute('disabled') || target.getAttribute('aria-disabled') === 'true';
        this.button.toggleAttribute('disabled', disabled);
      }
    }
  );
}
